// extracted by mini-css-extract-plugin
module.exports = {"modal-body":"ConfirmModal_modal-body__0xV4d","modal__header":"ConfirmModal_modal__header__ZgcsG","modal-footer":"ConfirmModal_modal-footer__yCS8o"};